<!-- Not Authorized -->
<div
  style="height: 100%; width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center"
>
  <h2>Not Authorized</h2>
  <h4>You don't have access to the system. Please contact help desk.</h4>
</div>
<!-- Not Authorized -->
